// @react/hooks/useLicense.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { licenseStore } from '@core/stores';

/**
 * React hook for License operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useLicense } from '@react/hooks';
 *
 * const LicenseList = observer(() => {
 *   const store = useLicense();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useLicense() {
  return licenseStore;
}
